import { Button, EmptyState, ErrorState } from '@convometry/ui';
import { Compass } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { usePageTitle } from '../app/title.js';

export function NotFoundPage() {
  usePageTitle('No encontrado');
  return (
    <div className="grid min-h-[60vh] place-items-center p-4">
      <EmptyState
        icon={<Compass aria-hidden />}
        title="Página no encontrada"
        description="La dirección no existe o no tienes acceso a ella."
        action={
          <Button asChild variant="secondary">
            <Link to="/">Ir al inicio</Link>
          </Button>
        }
      />
    </div>
  );
}

export function RouteErrorPage() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : undefined;
  return (
    <div className="grid min-h-dvh place-items-center bg-surface-canvas p-4">
      <ErrorState
        title="Algo salió mal"
        description={message ?? 'Ocurrió un error inesperado en la aplicación.'}
        action={<Button onClick={() => window.location.reload()}>Recargar</Button>}
      />
    </div>
  );
}
